<template>
  <router-view></router-view>
</template>

<script>
import '@/assets/css/tours-custom.css'
import { env } from './helpers';

export default {
  name: 'App',
  mounted() {
    var search = window.location.search;
    var userId = search.split('?c=')[1];
    var domain = window.location.host;
    domain = domain.replace('cms.', '');

    if (env.DEV_USER_ID) { // development only
      userId = env.DEV_USER_ID
    }

    if (env.DEV_DOMAIN) { // development only
      domain = env.DEV_DOMAIN
    }

    if (userId)
      this.$router.push({ name: 'Home', state: { dominio: domain, user_hash: userId } })
    else
      window.location.href = 'https://clientes.solucionesamedida.com/';

  }
}
</script>
